<template lang='pug'>
div
	v-item-group(v-model="selectedCarnetType")
		div.tw-flex.tw-flex-row.tw-justify-start(class="tw-mb-[20px]")
			v-item(v-for="(item, i) of carnetTypes" :key="i" :value="item.value")
				div.tw-cursor-pointer(
					:class="{'buy-type-base-item': true, 'active': selectedCarnetType == item.value}"
					@click="changeCarnetType(item.value)"
				)
					span(class="tw-font-bold tw-text-[14px]") {{item.label}}
	v-window(v-model="selectedCarnetType")
		v-window-item(value="purchase")
			purchase-with-reservation(v-if="'classic' == selectedPurchaseType.value" ref="purchaseCarnetFormReservation")
			purchase-regional-carnet(v-if="'regional' == selectedPurchaseType.value")
		v-window-item(value="booking" )
			find-purchased-carnet(ref="bookingCarnetForm")

	teleport(:to="outOfCard" :disabled="!outOfCard")
		div.tw-flex.tw-justify-end.tw-mb-10(
			v-if="'purchase' == selectedCarnetType || (bookingStore.carnet.fund ? false : true && 'booking' == selectedCarnetType)"
			class="emd:tw-justify-center"
		)
			v-btn(
				v-if="'purchase' == selectedCarnetType"
				color="primary-darken-1"
				:rounded="0"
				class="mr-6 tw-px-12"
				@click="search()"
				) {{$t('sale.carnet_form.find_solutions', 'CERCA SOLUZIONI')}}
			v-btn(
				v-if="bookingStore.carnet.fund ? false : true && 'booking' == selectedCarnetType"
				color="primary-darken-1"
				class="mr-6 tw-px-12"
				:rounded="0"
				@click="confirm()"
				:loading="confirmLoading"
			) {{$t('sale.carnet_form.find_carnet', 'CERCA CARNET ACQUISTATO')}}

		div.tw-card.tw-bg-white(v-if="'booking' == selectedCarnetType && bookingStore.carnet.fund" class="emd:tw-mb-10")
			v-row.ma-0.pa-0
				v-col.text-h6.pl-0(cols="12" md="6" class="tw-pb-0") {{$t('sale.carnet_form.carnet_purchased', 'Carnet acquistati')}}:&nbsp;
					strong {{bookingStore.carnet.fund.entitlements.currentUsages}}
				v-col.text-h6.pl-0.tw-text-right(cols="12" md="6" class="emd:tw-text-left emd:tw-pt-0") {{$t('sale.carnet_form.remaning_purchases', 'Acquisti rimanenti')}}:&nbsp;
					strong {{parseInt(bookingStore.carnet.fund.entitlements.maxUsages) - parseInt(bookingStore.carnet.fund.entitlements.currentUsages)}}
				//v-col.text-h6.pl-0.text-right(cols="12" md="4") Valido fino al: {{parseInt(bookingStore.carnet.fund.entitlements.maxUsages) - parseInt(bookingStore.carnet.fund.entitlements.currentUsages)}}

			v-form(ref='purchCarnetResForm' @submit.prevent v-if="bookingStore.carnet.fund")
				stations-fields(:show-switch="true" :disabled="true")
				div.tw-flex
					date-time-input(v-model="bookingStore.searchFilters.startDate" class="tw-basis-1/2")
				div.tw-flex
					div.tw-flex-1
					div
						v-btn(color="primary-darken-1" class="mr-6" @click="search()") {{'purchase' == selectedCarnetType ? $t('common.find', 'CERCA') : $t('common.find_solutions', 'CERCA SOLUZIONI').toUpperCase()}}
</template>


<script setup>
import {inject, ref, shallowRef} from 'vue';
import { onMounted } from 'vue';
import { useBookingStore } from '@/stores/booking';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import {useDialogManagerStore} from "@/stores/dialog-manager";
import PurchaseWithReservation from "@/sale/components/tab1_search/carnet/purchaseWithReservation.vue";
import PurchaseRegionalCarnet from "@/sale/components/tab1_search/carnet/purchaseRegionalCarnet.vue";
import FindPurchasedCarnet from "@/sale/components/tab1_search/carnet/find-purchased-carnet.vue";
import StationsFields from "@/sale/components/tab1_search/stations-fields.vue";
import DateTimeInput from '@/common-components/inputs/date-time-input.vue';
import {useI18n} from "vue-i18n";
import {findStationByID, useStations} from "@/composables/stations";


const i18n = useI18n();
const carnetTypes = [
	{
		label: i18n.t('form_labels.carnet.buy', 'ACQUISTA'),
		value: 'purchase'
	},
	{
		label: i18n.t('form_labels.carnet.booking', 'PRENOTA'),
		value: 'booking'
	}
];
const purchaseTypes = [
	{
		label: i18n.t('form_labels.carnet.purchase_carnet', 'Carnet con prenotazione'),
		value: 'classic',
		isSelected: true
	},
	{
		label: i18n.t('form_labels.carnet.purchase_regional_carnet', 'Carnet regionale'),
		value: 'regional',
		isSelected: false
	}
];
const selectedCarnetType = ref('purchase');
const selectedPurchaseType = ref(purchaseTypes[0]);
const stepper = useBookingStepperStore();
const bookingStore = useBookingStore();
const axios = inject('axios');
const confirmLoading = ref(false);
const bookingCarnetForm = ref(null);
const purchaseCarnetFormReservation = ref(null);
const dialogManagerStore = useDialogManagerStore();


defineProps(['outOfCard'])

function search(){
	(async () => {
		await purchaseCarnetFormReservation.value.purchaseCarnetFormReservation.validate();

		if('true' != import.meta.env.VITE_SAVE_IN_SESSION_STORAGE) sessionStorage.removeItem('travel-solutions');
		stepper.goNext();
	})().catch(e => {
		confirmLoading.value = false;
		console.error(e);
	});
}
async function confirm(){
	confirmLoading.value = true;
	const {valid} = await bookingCarnetForm.value.purchasedCarnetForm.validate();

	const toSend = {
		carnetNumber: bookingCarnetForm.value.purchasedCarnetForm.carnetNumber.value,
		name: bookingCarnetForm.value.purchasedCarnetForm.name.value,
		surname: bookingCarnetForm.value.purchasedCarnetForm.surname.value
	};

	axios.post('trenitalia/find-carnet', toSend)
	.then(res => {
		if (res.data.error) {
			const message = res.data.error.indexOf('Credintials incorrect') >= 0 ? i18n.t('dialogs.errors.credential_incorrects') : res.data.error;
			useDialogManagerStore().showErrorDialogFromError( res.data.error, {
				title: i18n.t('dialogs.warning'),
				message: message,
				showOK: true
			});
			return ;
		}

		if('true' == import.meta.env.VITE_CHANGE_CUSTOMEREMAIL) {
			if(!import.meta.env.VITE_TRAVELLER_EMAIL) throw new Error('Assegna una email a "VITE_TRAVELLER_EMAIL" nel file .env');
			res.data.travellers.email = import.meta.env.VITE_TRAVELLER_EMAIL;
		}


		bookingStore.carnet.fund = res.data;
		bookingStore.searchFilters.adult = 1;
		bookingStore.searchFilters.children = 0;
		bookingStore.searchFilters.departureStation = findStationByID(bookingStore.carnet.fund.solutionNodes.start.id);
		bookingStore.searchFilters.arrivalStation = findStationByID(bookingStore.carnet.fund.solutionNodes.end.id);
		bookingStore.setStartDate(new Date);
		bookingStore.resetTravellers(res.data.travellers);
		confirmLoading.value = false;
	})
	.catch((e) => {
		if (404 == e.response.status) {
			dialogManagerStore.openSimpleMessageDialog({
				messageType: 'error',
				title: i18n.t('dialogs.warning', 'Attenzione'),
				text: i18n.t('sale.carnet_form.incorrect_credentials', 'Credenziali errate, per favore ricontrollare')
			});
		}
		console.error(e);
	})
	.finally(() => {
		confirmLoading.value = false;
	});
}
function changeCarnetType(carnetType) {
	bookingStore.carnet.fund = null;
	selectedCarnetType.value = carnetType;
	if ('booking' == carnetType) {
		const tmp = new Date();
		bookingStore.searchFilters.startDate.setHours(tmp.getHours());
	} else {
		bookingStore.searchFilters.startDate.setHours(0);
		bookingStore.searchFilters.startDate.setMinutes(0);
		bookingStore.searchFilters.startDate.setSeconds(0);
	}
}

onMounted(() => {
	if (stepper.step == 'search' && 'carnet' == stepper.bookingType) {
		bookingStore.searchFilters.startDate.setHours(0);
		bookingStore.searchFilters.startDate.setMinutes(0);
		bookingStore.searchFilters.startDate.setSeconds(0);
	}
});
</script>

<style scoped>
.buy-type-base-item:first-child{
	border-bottom-right-radius: 0px;
	border-top-right-radius: 0px;
}

.buy-type-base-item:last-child{
	border-bottom-left-radius: 0px;
	border-top-left-radius: 0px;
}

.buy-type-base-item{
	padding: 10px 30px;
	border-radius: 16px;
	border: solid 2px #bcbcbc;
	color: #bcbcbc;
}
.buy-type-base-item.active{
	color: var(--color-primary);
	border: solid 2px var(--color-primary);
	background-color: rgba(88, 174, 228, 0.2);
}
</style>